var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "hover"
    },
    on: {
      "show": _vm.getQrcodeImage
    },
    scopedSlots: _vm._u([{
      key: "reference",
      fn: function () {
        return [_c('el-button', {
          staticClass: "margin-left-8 noPadding",
          attrs: {
            "type": "text"
          }
        }, [_vm._v(_vm._s(_vm.$t("common.Follow-Official")))])];
      },
      proxy: true
    }])
  }, [_c('el-image', {
    staticStyle: {
      "width": "200px",
      "height": "200px"
    },
    attrs: {
      "src": _vm.wechatQRCodeLink
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function () {
        return [_c('div', {
          staticClass: "image-slot"
        }, [_vm._v(_vm._s(_vm.$t("common.jia-zai-zhong"))), _c('span', {
          staticClass: "dot"
        }, [_vm._v("...")])])];
      },
      proxy: true
    }, {
      key: "error",
      fn: function () {
        return [_c('div', {
          staticClass: "image-slot"
        }, [_vm._v(_vm._s(_vm.$t("common.jia-zai-zhong"))), _c('span', {
          staticClass: "dot"
        }, [_vm._v("...")])])];
      },
      proxy: true
    }])
  }), _c('p', {
    staticStyle: {
      "line-height": "30px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t("common.Scan-Follow")))])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };